var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data && _vm.data.name
    ? _c("div", { staticClass: "location-info" }, [
        _c("h2", {
          staticClass: "location-info__heading",
          domProps: { textContent: _vm._s(_vm.data.name) }
        }),
        _vm._v(" "),
        _vm.data.description
          ? _c("p", {
              staticClass: "location-info__text",
              domProps: { textContent: _vm._s(_vm.data.description) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.data.waterTemperature || _vm.data.airTemperature
          ? _c("div", { staticClass: "location-info__temp" }, [
              _c("p", {
                domProps: { textContent: _vm._s(_vm.temperatureDates) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "temp-info" }, [
                _vm.data.waterTemperature
                  ? _c("div", { staticClass: "temp-info__item" }, [
                      _c("img", {
                        attrs: {
                          src: require("./../../img/icons/icon-temp-water.svg"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.data.waterTemperature) + "°C")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.airTemperature
                  ? _c("div", { staticClass: "temp-info__item" }, [
                      _c("img", {
                        attrs: {
                          src: require("./../../img/icons/icon-temp-sun.svg"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.data.airTemperature) + "°C")
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5213d782", { render: render, staticRenderFns: staticRenderFns })
  }
}